export class CashAdvanceFilter {
    recieverId: number;
    releasedById: number;
    dateRecievedFrom: string;
    dateRecievedTo: string;
    createdDateFrom: string;
    createdDateTo: string;

    createdDate: string; // mm/dd/yyyy
    createdBy: number;
    updatedDate: string;
    updatedBy: number;
}


// WEBPACK FOOTER //
// ./src/app/models/cashAdvances/cash.advance.filter.ts